import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  @Input() colorClass = '';
  currentYear = new Date().getFullYear();

  scrollToSection(event: Event, id: string): void {
    event.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  goToPromotorForm() {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdl_dWgRd1KHzjKesnuKCOvOiBjutFZhH0LUF_YOLbPZjNM0w/viewform', '_blank');
  }
  
}
